import { render } from "./MiniCardAcao.vue?vue&type=template&id=43570d0f"
import script from "./MiniCardAcao.vue?vue&type=script&lang=js"
export * from "./MiniCardAcao.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__